module.exports = __webpack_public_path__ + "img/of1.8754c070.png";